import React, { MouseEvent, useCallback, useEffect, useState } from 'react';
import {
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Menu,
  MenuItem,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from '@material-ui/core';
import { MoreVert, ExpandMore } from '@material-ui/icons';

import { FaInfo } from 'react-icons/fa';

import api from '../../../../services/api';

import { useToast } from '../../../../hooks/toast';

import DeleteGrupo from '../AcordeaoSimples/DeleteGrupo';
import EditGrupoPizza from '../Drawers/Grupos/Edit/EditGrupoPizza';
import NewProdutoPizza from '../Drawers/Produtos/NewProdutoPizza';
import TableRowProdutoPizza from './TableRowProdutoPizza';

import { useRegisterAdded } from '../../../../hooks/registerAdded';
import styles from '../styles/material_styles';
import {
  AccordionTitle,
  InfoHeaderButton,
  StatusSaleButton,
  ButtonsWrapper,
} from '../styles';

interface ObjectType {
  id: number;
  grupo_id: number;
  descricao: string;
  tamanho: number;
  preco: number;
  observacao?: string;
  grupo_produto_id?: number;
  gtin?: string;
  imagem?: string;
  tamanhos: any[];
  unidade_medida_id: number;
  pausar_venda: boolean;
  ativo: boolean;
  ordem: number;
}

interface AccordionProps {
  grupo_id: number;
  descricao: string;
  pausar_venda: boolean;
  tipo_produto: number;
  imagem: string;
}

const ITEM_HEIGHT = 48;

const Acordeao: React.FC<AccordionProps> = ({
  grupo_id,
  descricao,
  pausar_venda,
  tipo_produto,
  imagem,
}) => {
  const classes = styles();

  const { addToast } = useToast();
  const { hasProductUpdated } = useRegisterAdded();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [vendaPausada, setVendaPausada] = useState(pausar_venda);
  const [products, setProducts] = useState<ObjectType[]>();

  const open = Boolean(anchorEl);

  useEffect(() => {
    async function loadProducts(): Promise<void> {
      const productsResponse = await api.get(
        `/grupo/grupo_produto/${grupo_id}`,
      );

      const prices = await api.get(`/produto/preco/${grupo_id}`);

      const newProducts: ObjectType[] = [];
      let grupo_produto_id = 0;

      await Promise.all(
        productsResponse.data.map(
          async ({ produto }: any): Promise<void> => {
            let lowestPrice = 0;
            let tamanho = 0;
            let tamanhos: any[] = [];
            let ativo = false;

            const tamanhosResponse = await api.get(
              `/produto/grade/produto/${produto.id}`,
            );

            const estoqueResponse = await api.get(
              `/estoque/estoque_produto/${produto.id}`,
            );

            tamanhosResponse.data.forEach((tamanhoItem: any) => {
              if (tamanhoItem.tamanho_id && tamanhoItem.ativo) {
                tamanho += 1;
              }

              ativo = tamanhoItem.ativo;
              grupo_produto_id = tamanhoItem.grupo_produto_id;

              tamanhos.push({
                id: tamanhoItem.tamanho.id,
                descricao: tamanhoItem.tamanho.descricao,
                isSelected: tamanhoItem.ativo,
                codigo: tamanhoItem.codigo_grade,
                estoque_id: Number(
                  estoqueResponse.data.find(
                    (estoque: any) =>
                      estoque.produto_grade_id === tamanhoItem.id,
                  )?.id || 0,
                ),
                produto_grade_id: tamanhoItem.id,
                estoque_minimo: Number(
                  estoqueResponse.data.find(
                    (estoque: any) =>
                      estoque.produto_grade_id === tamanhoItem.id,
                  )?.estoque_minimo || 0,
                ),
                estoque_atual: Number(
                  estoqueResponse.data.find(
                    (estoque: any) =>
                      estoque.produto_grade_id === tamanhoItem.id,
                  )?.estoque_atual || 0,
                ),
              });

              prices.data.forEach((price: any) => {
                if (price.produto_grade_id === tamanhoItem.id) {
                  tamanhos = tamanhos.map((findTamanho) => {
                    if (findTamanho.id === price.tamanho_id) {
                      return {
                        ...findTamanho,
                        preco: Number(price.valor).toFixed(2),
                        preco_id: price.id,
                      };
                    }

                    return findTamanho;
                  });

                  if (tamanhoItem.ativo) {
                    if (Number(price.valor) < lowestPrice || !lowestPrice) {
                      lowestPrice = Number(price.valor);
                    }
                  }
                }
              });
            });

            newProducts.push({
              ativo,
              grupo_id,
              id: produto.id,
              grupo_produto_id,
              descricao: produto.descricao,
              imagem: produto.imagem,
              gtin: produto.gtin,
              unidade_medida_id: produto.unidade_medida_id,
              observacao: produto.observacao,
              pausar_venda: produto.pausar_venda,
              tamanho,
              tamanhos,
              preco: lowestPrice,
              ordem: produto.ordem,
            });
          },
        ),
      );

      setProducts(newProducts);
    }

    loadProducts();
  }, [grupo_id, hasProductUpdated]);

  const handleSetPausedGroup = useCallback(
    async (value: boolean) => {
      try {
        api
          .put(`/grupo/${grupo_id}`, { pausar_venda: value })
          .then((response) => {
            const { pausar_venda: pausarVenda } = response.data;
            setVendaPausada(pausarVenda);

            addToast({
              type: 'info',
              title: `Grupo ${descricao} ${
                pausarVenda ? 'desativado' : 'ativado'
              }.`,
            });
          });
      } catch (err) {
        const { message } = err.response.data;

        addToast({
          type: 'error',
          title: message,
        });
      }
    },
    [grupo_id, addToast, descricao],
  );

  const handleCloseMenuOptions = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleOpenMenuOptions = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    },
    [],
  );

  return (
    <div className={classes.root}>
      <Accordion expanded>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.accordionSummary}
        >
          <Grid container>
            <Grid item lg={4} md={4} xs={6}>
              <AccordionTitle>
                <div
                  onClick={(event) => event.stopPropagation()}
                  onFocus={(event) => event.stopPropagation()}
                >
                  <IconButton
                    aria-label="more"
                    aria-controls="options-menu"
                    aria-haspopup="true"
                    onClick={handleOpenMenuOptions}
                  >
                    <MoreVert />
                  </IconButton>
                  <Menu
                    id="options-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={open}
                    onClose={handleCloseMenuOptions}
                    PaperProps={{
                      style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '20ch',
                      },
                    }}
                  >
                    <MenuItem onClick={handleCloseMenuOptions}>
                      <EditGrupoPizza
                        grupo_pizza_id={grupo_id}
                        descricao={descricao}
                        image={imagem}
                        pausar_venda={pausar_venda}
                      />
                    </MenuItem>
                    <MenuItem onClick={handleCloseMenuOptions}>
                      <DeleteGrupo descricao={descricao} grupo_id={grupo_id} />
                    </MenuItem>
                  </Menu>
                </div>

                <div>
                  <h1>{descricao}</h1>
                </div>
              </AccordionTitle>
            </Grid>

            <Grid item lg={4} md={4} xs={6}>
              <NewProdutoPizza grupo_id={grupo_id} />
            </Grid>

            <Grid item lg={4} md={4}>
              <ButtonsWrapper>
                <div
                  onClick={(event) => event.stopPropagation()}
                  onFocus={(event) => event.stopPropagation()}
                >
                  <StatusSaleButton
                    type="button"
                    isPaused={!vendaPausada}
                    className="paused"
                    onClick={() => handleSetPausedGroup(true)}
                  >
                    Pausado
                  </StatusSaleButton>

                  <StatusSaleButton
                    type="button"
                    isPaused={vendaPausada}
                    className="activated"
                    onClick={() => handleSetPausedGroup(false)}
                  >
                    Ativado
                  </StatusSaleButton>
                </div>
              </ButtonsWrapper>
            </Grid>
          </Grid>
        </AccordionSummary>

        <AccordionDetails>
          <Grid container>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12}>
                  <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Item</TableCell>
                          <TableCell align="center">Tamanho</TableCell>

                          <TableCell align="center">
                            Preço
                            <InfoHeaderButton type="button">
                              <FaInfo size={8} />
                            </InfoHeaderButton>
                          </TableCell>

                          <TableCell align="center">Status de Venda</TableCell>

                          <TableCell />
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {products &&
                          products
                            .sort((a, b) => a.ordem - b.ordem)
                            .map((product) => (
                              <TableRowProdutoPizza
                                key={product.id}
                                product={product}
                              />
                            ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default Acordeao;
